import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Home";
import Tours from "../../pages/Tours";
import TourDetails from "../../pages/TourDetails";
import Login from "../../pages/Login";
import Register from "../../pages/Register";
import SearchResultList from "../../pages/SearchResultList";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ThankYou from "../../pages/ThankYou";
import About from "../../pages/About";
import TermsAndConditions from "../../pages/TermsAndConditions";
import Visa from "../../pages/visa";
import GroupTourIndia from "../../pages/GroupTourIndia";
import GroupTourInternational from "../../pages/GroupTourInternational";
import GroupTourInternationalDetails from "../../pages/GroupTourInternationalDetails";
import ChatWithUs from '../../ChatWithUs';

const Layout = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/tours/:id" element={<TourDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/tours/search" element={<SearchResultList />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/Visa" element={<Visa />} />
        <Route path="/GroupTourIndia" element={<GroupTourIndia />} />
        <Route path="/GroupTourInternational" element={<GroupTourInternational />} />
        <Route path="/grouptoursinternational/:id" element={<GroupTourInternationalDetails />} />
        <Route path="/chatwithus" component={ChatWithUs} />
      </Routes>
      <Footer />
    </>
  );
};

export default Layout;
